import $ from "../../../../libs/jquery-3.3.1.min.js";
import {gsap} from "../../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {TranslatableText} from "./TranslatableText";
import {AppearingContainer} from "./AppearingContainer";
import {InteractiveButton} from "./InteractiveButton";
import {AppearingInteractiveButton} from "./AppearingInteractiveButton";
import {Point} from "pixi.js";

// Constructor
export class TextPopup extends AppearingContainer {

  constructor(x, y, color, appearingScreenPercent, screenData, game) {
    if (screenData === undefined) return; // stop here if screen doesn't exist
    super(appearingScreenPercent, game);

    // top left position
    this.pos = {
      x: x,
      y: y
    }

    // Popup settings
    this.popupPadding = 128;
    this.spaceBetween = 60;

    this.textStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 90,
      fontWeight: 500,
      lineHeight: 100,
      fill: color,
      align: "left",
      padding: 5,
    });

    this.buttonSize = 256;
    this.buttonTextStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 40,
      fontWeight: 600,
      lineHeight: 40,
      fill: "#343B6F",
      align: "center",
    });

    this.popupTitleTextStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 96,
      lineHeight: 106,
      fill: "#343B6F",
    });

    this.popupTextStyle = new PIXI.TextStyle({
      fontFamily: "Halyard Display",
      fontSize: 64,
      lineHeight: 85,
      wordWrap: true,
      wordWrapWidth: 1400,
      fill: "#343B6F",
    });

    this.build(screenData);

    // Things that happen when language switch
    this.languageSwitchTimeline = false;

    this.languageSwitch(app.i18n.lang);
    $(document).on('i18nSet', (e) => {
      this.languageSwitch(e.lang);
    });
  }

  build(screenData) {

    this.textContainer = new PIXI.Container();
    this.textContainer.position = this.pos;
    this.popupContainer = new PIXI.Container();
    this.popupContainer.eventMode = "none";

    this.textWrapper = new PIXI.Container();
    this.textContainer.addChild(this.textWrapper);

    if (screenData.text && screenData.button) {
      // Text
      const textEN = new TranslatableText(screenData.text.en, this.textStyle, "en", this.game).getText();
      const textFR = new TranslatableText(screenData.text.fr, this.textStyle, "fr", this.game).getText();
      this.textWrapper.addChild(textEN);
      this.textWrapper.addChild(textFR);

      // Buttons
      this.buttonENContainer = this.buildButton(screenData.button.en, "en");
      this.buttonFRContainer = this.buildButton(screenData.button.fr, "fr");
      this.buttonENContainer.pivot.set(this.buttonSize / 2);
      this.buttonFRContainer.pivot.set(this.buttonSize / 2);

      // Add container on top of the animation for visibility control
      this.buttonENShownContainer = new PIXI.Container();
      this.buttonFRShownContainer = new PIXI.Container();
      this.buttonENShownContainer.position.set((textEN.width / 2), textEN.height + 64 + (this.buttonSize / 2));
      this.buttonFRShownContainer.position.set((textFR.width / 2), textFR.height + 64 + (this.buttonSize / 2));
      this.buttonENShownContainer.addChild(this.buttonENContainer);
      this.buttonFRShownContainer.addChild(this.buttonFRContainer);

      this.textContainer.addChild(this.buttonENShownContainer);
      this.textContainer.addChild(this.buttonFRShownContainer);
    }

    // Popup
    if (screenData.popup) {
      // Popup title
      const popupTitleEN = new TranslatableText(screenData.popup.title.en, this.popupTitleTextStyle, "en", this.game).getText();
      popupTitleEN.position.set(this.popupPadding, this.popupPadding);
      const popupTitleFR = new TranslatableText(screenData.popup.title.fr, this.popupTitleTextStyle, "fr", this.game).getText();
      popupTitleFR.position.set(this.popupPadding, this.popupPadding);

      // Popup text
      const popupTextEN = new TranslatableText(screenData.popup.text.en, this.popupTextStyle, "en", this.game).getText();
      popupTextEN.position.set(this.popupPadding, popupTitleEN.position.y + popupTitleEN.height + this.spaceBetween);
      const popupTextFR = new TranslatableText(screenData.popup.text.fr, this.popupTextStyle, "fr", this.game).getText();
      popupTextFR.position.set(this.popupPadding, popupTitleFR.position.y + popupTitleFR.height + this.spaceBetween);

      // Calculate popup width/height
      let width = Math.max(popupTitleEN.width, popupTitleFR.width, popupTextEN.width, popupTextFR.width);
      width = width + (this.popupPadding * 2);

      let height = Math.max((popupTitleEN.height + popupTextEN.height), (popupTitleFR.height + popupTextFR.height));
      height = height + this.spaceBetween + (this.popupPadding * 2);

      // Background
      const popupBackground = new PIXI.Graphics()
        .roundRect(0, 0, width, height, 32)
        .fill(0xFFFF9F);

      // Close button
      this.closeButton = new InteractiveButton(this.hidePopup.bind(this), true, "audio/MAF_Reactif_Boites.oga");
      let closeButtonSprite = new PIXI.Sprite(this.game.assets.cross);
      closeButtonSprite.setSize(64, 64);
      this.closeButton.addChild(closeButtonSprite);
      this.closeButton.position.set(popupBackground.width - this.closeButton.width - this.popupPadding, this.popupPadding + 20);

      this.popupContainer.addChild(popupBackground);
      this.popupContainer.addChild(this.closeButton);
      this.popupContainer.addChild(popupTitleEN);
      this.popupContainer.addChild(popupTitleFR);
      this.popupContainer.addChild(popupTextEN);
      this.popupContainer.addChild(popupTextFR);
      this.popupContainer.position.set(-this.popupContainer.width / 2, -this.popupContainer.height / 2);
      this.popupContainer.alpha = 0.0;
    }

    this.reset();
  }

  buildButton(text, langcode) {
    const container = new AppearingInteractiveButton(this.showPopup.bind(this), 0.75, this.game, "audio/MAF_Reactif_Boites.oga");

    // Background
    const buttonBackground = new PIXI.Graphics()
      .roundRect(0, 0, this.buttonSize, this.buttonSize, this.buttonSize / 2)
      .fill(0xFFFF9F);

    // Text
    const buttonText = new TranslatableText(text, this.buttonTextStyle, langcode, this.game).getText();
    buttonText.anchor.set(0.5, 0.5);
    buttonText.position.set(this.buttonSize / 2, this.buttonSize / 2);

    // Arrow
    const arrow = new PIXI.Sprite(this.game.assets.arrow_right);
    arrow.setSize(50, 30);
    arrow.anchor.set(0.5, 0.5);
    arrow.position.set(this.buttonSize / 2, this.buttonSize - 47);

    container.addChild(buttonBackground);
    container.addChild(buttonText);
    container.addChild(arrow);
    return container;
  }

  languageSwitch(lang) {
    // Kill timeline
    if (this.languageSwitchTimeline) {
      this.languageSwitchTimeline.kill();
      this.languageSwitchTimeline = false;
    }

    this.languageSwitchTimeline = gsap.timeline();
    const containerToHide = lang === "en" ? this.buttonFRShownContainer : this.buttonENShownContainer;
    const containerToShow = lang === "en" ? this.buttonENShownContainer : this.buttonFRShownContainer;
    containerToHide.eventMode = "none";
    containerToShow.eventMode = "passive";
    this.languageSwitchTimeline.to(containerToHide, {alpha: 0.0, duration: 0.4}, 0.0);
    this.languageSwitchTimeline.to(containerToShow, {alpha: 1.0, duration: 0.4}, 0.4);
  }

  getText() {
    return this.textContainer;
  }

  getPopup() {
    return this.popupContainer;
  }

  showPopup() {
    this.game.disableUI();
    this.buttonENContainer.eventMode = "none";
    this.buttonFRContainer.eventMode = "none";
    this.closeButton.eventMode = "static";
    this.popupContainer.eventMode = "passive";
    gsap.to(this.popupContainer, {alpha: 1.0, duration: 0.4, ease: 'sine.inOut'})
  }

  hidePopup() {
    this.game.enableUI();
    this.buttonENContainer.eventMode = "static";
    this.buttonFRContainer.eventMode = "static";
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
    gsap.to(this.popupContainer, {alpha: 0.0, duration: 0.4, ease: 'sine.inOut'});
  }

  buildAnimations() {
    this.inAnimation = gsap.timeline({immediateRender: true, paused: true});
    this.inAnimation.fromTo([this.textContainer, this.buttonENContainer, this.buttonFRContainer], {
      alpha: 0.0
    }, {
      alpha: 1.0,
      ease: "sine.inOut",
      duration: 1.0
    }, 0.0);
  }

  // Function called when the animateIn fonction from the AppearingContainer Class is called
  // Useful to do more actions without overwriting the base animateIn function
  animateInAddons() {
    // Enable interaction with popup trigger button
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
    this.enable();
  }

  enable() {
    this.buttonENContainer.eventMode = "static";
    this.buttonFRContainer.eventMode = "static";
  }

  disable() {
    this.buttonENContainer.eventMode = "none";
    this.buttonFRContainer.eventMode = "none";
    this.closeButton.eventMode = "none";
    this.popupContainer.eventMode = "none";
  }

  getPositionOnScreen() {
    return this.getText().toGlobal(new Point(0, 0));
  }

  reset() {
    super.reset();
    this.buttonENContainer.reset();
    this.buttonFRContainer.reset();
  }

}
